export class Message {    
    constructor(
        public type: string,
        public payload: any,
      ) {}
}